/* Arizona stays on MST (UTC−07:00) year round. Editor dates use YYYY-MM-DD HH:MM. */
(function () {
  function timestamp(value) {
    if (!value) return null;
    var trimmed = value.trim();
    if (!/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}$/.test(trimmed)) return NaN;
    return Date.parse(trimmed.replace(' ', 'T') + ':00-07:00');
  }
  function active(node, now) {
    var start = timestamp(node.dataset.ggStart);
    var end = timestamp(node.dataset.ggEnd);
    if (Number.isNaN(start) || Number.isNaN(end)) return false;
    return (start === null || now >= start) && (end === null || now < end);
  }
  function initAnnouncements(root) {
    root.querySelectorAll('.gg-announcements').forEach(function (holder) {
      if (holder.dataset.ggInitialized) return;
      holder.dataset.ggInitialized = 'true';
      var messages = Array.from(holder.querySelectorAll('.gg-announcements__message'));
      var fallback = holder.querySelector('.gg-announcements__fallback');
      var controls = holder.parentElement.querySelector('.gg-announcements__controls');
      var index = 0;
      var visible = [];
      function update(advance) {
        visible = messages.filter(function (node) { return active(node, Date.now()); });
        if (advance) index += advance;
        if (index >= visible.length) index = 0;
        if (index < 0) index = Math.max(visible.length - 1, 0);
        messages.forEach(function (node) { node.classList.remove('is-active'); });
        fallback.classList.toggle('is-active', visible.length === 0);
        if (visible.length) visible[index].classList.add('is-active');
        controls.hidden = visible.length < 2;
      }
      controls.querySelector('[data-gg-announcement-prev]').addEventListener('click', function () { update(-1); });
      controls.querySelector('[data-gg-announcement-next]').addEventListener('click', function () { update(1); });
      update(0);
      var seconds = Math.max(4, Number(holder.dataset.ggRotateSeconds) || 7);
      var elapsed = 0;
      var timer = setInterval(function () {
        if (!holder.isConnected) return clearInterval(timer);
        elapsed++;
        var pause = holder.matches(':hover') || holder.contains(document.activeElement) || document.hidden;
        update(!pause && elapsed % seconds === 0 ? 1 : 0);
      }, 1000);
    });
  }
  function initShowcases(root) {
    root.querySelectorAll('[data-gg-scheduled-section]').forEach(function (section) {
      if (section.dataset.ggInitialized) return;
      section.dataset.ggInitialized = 'true';
      function update() { section.hidden = !active(section, Date.now()); }
      update();
      var timer = setInterval(function () {
        if (!section.isConnected) return clearInterval(timer);
        update();
      }, 15000);
    });
  }
  function init(root) { initAnnouncements(root); initShowcases(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
